// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"o2-z","dimensionLabel":"p2-z","styleChooserControlWrapper":"q2-z","styleChooserControl":"r2-z","disabled":"s2-z","giftCard":"t2-z","styleChooserText":"u2-z"};